import React, { FC } from "react";
import { Translate } from "../../components/translations";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";
import './styles.scss';

const ContentMonitoring: FC = () => (
  <div className="content-wrapper">
    <PageHero
      title="Content monitoring"
      subtitle="Monitor the visible content on a web page for any changes."
    />
    <Layout>
      <Section>
        <div className="col-lg-12">
        </div>
      </Section>
    </Layout>
  </div>
);

export default ContentMonitoring;
